(()=>{
 document.querySelectorAll('#shopify-section-knl-swivel,#shopify-section-knl-row').forEach(root=>{
  const hero=root.querySelector('.ks-landmine-handle-hero');
  const heading=hero?.querySelector('h1');
  const title=heading?.textContent.trim();
  if(title==='Landmine Swivel Handle'||title==='Landmine Row Handle'){
   heading.replaceChildren(document.createTextNode('Landmine '));
   const emphasis=document.createElement('span');
   emphasis.className='lm-hero-em';
   emphasis.textContent=title.replace('Landmine ','');
   heading.append(emphasis);
  }
  hero?.querySelectorAll('a.ks-assurance-item').forEach(link=>{
   const item=document.createElement('div');
   item.className=link.className;
   while(link.firstChild)item.append(link.firstChild);
   link.replaceWith(item);
  });
 });
})();
